<template>
  <div class="mb-2 toggle-button">
    <input
      type="radio"
      :id="`radio-one-${componentId}`"
      :name="`option-${componentId}`"
      v-model="activeOption"
      :value="1"
      @change="updateModelValue"
    />
    <label data-testid="left-label" :for="`radio-one-${componentId}`">
      {{ leftLabel }}</label
    >
    <input
      type="radio"
      :id="`radio-two-${componentId}`"
      :name="`option-${componentId}`"
      v-model="activeOption"
      :value="2"
      @change="updateModelValue"
    />
    <label data-testid="right-label" :for="`radio-two-${componentId}`">{{
      rightLabel
    }}</label>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, toRefs } from "vue";

const props = defineProps({
  leftLabel: {
    type: String,
    default: "left",
  },
  rightLabel: {
    type: String,
    default: "right",
  },
  defaultActiveOption: {
    type: Number,
    default: 1,
  },
});

const emits = defineEmits(["updateSwitch"]);
const { leftLabel, rightLabel } = toRefs(props);
const activeOption = ref(props.defaultActiveOption);
const componentId = ref("");

function updateModelValue() {
  emits("updateSwitch", activeOption.value);
}

onMounted(() => {
  componentId.value = Math.random().toString(36).substr(2, 9);
});
</script>
<style lang="scss">
@import "@/assets/scss/_constants.scss";

.toggle-button {
  display: flex;
  overflow: hidden;
}

.toggle-button input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}

.toggle-button label {
  background-color: white;
  color: black;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  padding: 8px 16px;
  margin-right: -1px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  transition: all 0.1s ease-in-out;
}

.toggle-button label:hover {
  cursor: pointer;
}

.toggle-button input:checked + label {
  background-color: $pj-color-green;
  box-shadow: none;
  color: white;
}

.toggle-button label:first-of-type {
  border-radius: 4px 0 0 4px;
}

.toggle-button label:last-of-type {
  border-radius: 0 4px 4px 0;
}
</style>
